import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-cms',
  template: `
    <p>
      cms works!
    </p>
  `,
  styles: []
})
export class CmsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
